import React, { Component } from 'react'

export default class SectionHeader extends Component {
  render() {
    const { name, number, heading, ...props } = this.props;
    return (
      <div className="grid" {...props}>
        <h2 className="text-hugeltpurple h6 mt-0 mb-5">{number}. {name}</h2>
        <h3 className="text-hugeorange h2 mt-0 mb-10">{heading}</h3>
        <hr className="bg-hugeltpurple w-full mt-0 mb-16" />
      </div>
    )
  }
}
